"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const client_1 = require("@apollo/client");
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
const lodash_1 = require("lodash");
const ordersCopy_1 = require("copy/ordersCopy");
const OrderModal_1 = __importDefault(require("components/Dashboard/Modals/OrderModal"));
const useInfiniteScroll_1 = require("hooks/useInfiniteScroll");
const usePaginatedSearch_1 = __importDefault(require("components/usePaginatedSearch"));
const DateFormat_1 = require("components/general/utility/DateFormat");
const ProblemOrdersIcon_1 = require("components/ProblemOrdersIcon");
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const ProblemOrdersRules_1 = require("./ProblemOrdersRules");
const AccountContext_1 = require("contexts/AccountContext");
const graphql_1 = require("./graphql");
const styles_1 = require("./styles");
const ErrorMessage_1 = require("./ErrorMessage");
const EmptyState_1 = require("./EmptyState");
const pageCount = 12;
const ISSUE_FILTERS = [
    { label: 'All', value: 'ALL' },
    { label: 'Delivery Attempted', value: 'ShipmentDeliveryAttempted' },
    { label: 'Return to Sender', value: 'ShipmentReturnedToSender' },
    { label: 'Stalled in Transit', value: 'ShipmentStalled' }
];
const STATUS_FILTERS = [
    { label: 'All', value: 'ALL' },
    { label: 'Delivered', value: 'delivered' },
    { label: 'Out for Delivery', value: 'out_for_delivery' },
    { label: 'In Transit', value: 'in_transit' },
    { label: 'Pre Transit', value: 'pre_transit' },
    { label: 'Return to sender', value: 'return_to_sender' },
    { label: 'Available for Pickup', value: 'available_for_pickup' },
    { label: 'Cancelled', value: 'cancelled' },
    { label: 'Bad Tracking Code Error', value: 'bad_tracking_code_error' },
    { label: 'Unknown', value: 'unknown' }
];
function buildFilterLabel(label, values, choiceList) {
    var _a;
    if (values.length) {
        const issuesString = (_a = values === null || values === void 0 ? void 0 : values
        // don't show 'all' in filter tags
        .filter((value) => value !== 'ALL')) === null || _a === void 0 ? void 0 : _a.map((value) => {
            var _a;
            return (((_a = choiceList.find(({ value: filterValue }) => filterValue === value)) === null || _a === void 0 ? void 0 : _a.label) || 'error');
        }).join(', ');
        return `${label}: ${issuesString}`;
    }
    return '';
}
function computeFiltersChange(oldFilters, newFilters, choiceList) {
    let result = [];
    const decreaseFilterCount = !!newFilters && !!oldFilters && newFilters.length < oldFilters.length;
    if ((oldFilters === null || oldFilters === void 0 ? void 0 : oldFilters.includes('ALL')) && decreaseFilterCount) {
        // deselect 'ALL' if one of the filters was deselected while ALL was
        // selected
        result = newFilters.filter((filter) => filter !== 'ALL');
    }
    else if (newFilters === null || newFilters === void 0 ? void 0 : newFilters.includes('ALL')) {
        // If ALL was selected, mark all filters as selected
        result = choiceList.map(({ value }) => value);
    }
    else {
        // regular filter update
        result = newFilters;
    }
    return result;
}
// eslint-disable-next-line complexity
const Orders = () => {
    var _a, _b, _c, _d, _e, _f;
    const { account } = (0, AccountContext_1.useAccount)();
    const [detailedOrder, setDetailedOrder] = (0, react_1.useState)();
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [showProblemOrderRules, setShowProblemOrderRules] = (0, react_1.useState)(false);
    const [getOrders, { loading, data, fetchMore, error }] = (0, client_1.useLazyQuery)(graphql_1.GET_ORDERS);
    const [searchQuery, setSearchQuery] = (0, react_1.useState)('');
    const [problemOrderFilters, setProblemOrderFilters] = (0, react_1.useState)([]);
    const [statusFilters, setStatusFilters] = (0, react_1.useState)([]);
    const { id: accountId } = account || {};
    const flags = (0, launchdarkly_react_client_sdk_1.useFlags)();
    // watch for account changes
    (0, react_1.useEffect)(() => {
        if (accountId) {
            getOrders({ variables: { accountId, first: pageCount } });
        }
    }, [accountId]);
    const { searched, handleSearch, handleLoadNext } = (0, usePaginatedSearch_1.default)(fetchMore, 'orders', data);
    const debouncedHandleSearch = (0, react_1.useMemo)(() => (0, lodash_1.debounce)(handleSearch, 500), [handleSearch]);
    const onQueryChange = (0, react_1.useCallback)((query) => {
        setSearchQuery(query);
        debouncedHandleSearch(query);
    }, [debouncedHandleSearch]);
    (0, useInfiniteScroll_1.useInfiniteScroll)({
        hasNext: ((_b = (_a = data === null || data === void 0 ? void 0 : data.orders) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.hasNextPage) || false,
        loadNext: handleLoadNext
    });
    const handleToggleModal = () => {
        setShowModal((current) => !current);
    };
    const handleProblemOrdersSelected = (0, react_1.useCallback)((newFilters) => {
        if (!accountId) {
            return;
        }
        const computedFilters = computeFiltersChange(problemOrderFilters, newFilters, ISSUE_FILTERS);
        setProblemOrderFilters(computedFilters);
        getOrders({
            variables: {
                accountId,
                first: pageCount,
                issues: computedFilters.length ? computedFilters : undefined,
                shipmentStatuses: statusFilters.length ? statusFilters : undefined
            }
        });
    }, [accountId, searchQuery, getOrders, statusFilters, problemOrderFilters]);
    const handleStatusesSelected = (0, react_1.useCallback)((newFilters) => {
        if (!accountId) {
            return;
        }
        const computedFilters = computeFiltersChange(statusFilters, newFilters, STATUS_FILTERS);
        setStatusFilters(computedFilters);
        getOrders({
            variables: {
                accountId,
                first: pageCount,
                issues: problemOrderFilters.length ? problemOrderFilters : undefined,
                shipmentStatuses: computedFilters.length ? computedFilters : undefined
            }
        });
    }, [accountId, searchQuery, getOrders, statusFilters, problemOrderFilters]);
    const handleReset = () => {
        if (!accountId) {
            return;
        }
        setStatusFilters([]);
        setProblemOrderFilters([]);
        getOrders({
            variables: {
                accountId,
                first: pageCount,
                issues: undefined,
                shipmentStatuses: undefined
            }
        });
    };
    const filters = flags.statusFilter
        ? [
            {
                key: 'problemOrders',
                label: 'Problem Orders',
                filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: ISSUE_FILTERS, onChange: handleProblemOrdersSelected, selected: problemOrderFilters, title: 'Problem Orders', titleHidden: true })),
                shortcut: true
            },
            {
                key: 'shipmentStatus',
                label: 'Status',
                filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: STATUS_FILTERS, onChange: handleStatusesSelected, selected: statusFilters, title: 'Status', titleHidden: true })),
                hideClearButton: true,
                shortcut: true
            }
        ]
        : [
            {
                key: 'problemOrders',
                label: 'Problem Orders',
                filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: ISSUE_FILTERS, onChange: handleProblemOrdersSelected, selected: problemOrderFilters, title: 'Problem Orders', titleHidden: true })),
                shortcut: true
            }
        ];
    const appliedFilters = [];
    if (!(0, lodash_1.isEmpty)(problemOrderFilters)) {
        appliedFilters.push({
            key: 'problemOrders',
            label: buildFilterLabel('Problem Orders', problemOrderFilters, ISSUE_FILTERS),
            onRemove: () => handleProblemOrdersSelected([])
        });
    }
    if (!(0, lodash_1.isEmpty)(statusFilters)) {
        appliedFilters.push({
            key: 'statuses',
            label: buildFilterLabel('Status', statusFilters, STATUS_FILTERS),
            onRemove: () => handleStatusesSelected([])
        });
    }
    const resourceName = {
        singular: 'order',
        plural: 'orders'
    };
    const orders = ((_d = (_c = data === null || data === void 0 ? void 0 : data.orders) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.map(({ node }) => node)) || [];
    const ordersHaveIssues = !!orders.find((order) => order.issues.edges.length > 0);
    const handleClearAll = (0, react_1.useCallback)(() => {
        handleSearch('');
        handleReset();
    }, [handleSearch, handleProblemOrdersSelected, handleStatusesSelected]);
    const hasFilters = !(0, lodash_1.isEmpty)(problemOrderFilters) || !(0, lodash_1.isEmpty)(statusFilters) || !!searchQuery;
    const rowMarkup = orders.map((order, index) => {
        var _a;
        const customerFullName = order.customer
            ? `${order.customer.firstName} ${order.customer.lastName}`
            : 'N/A';
        return (react_1.default.createElement(polaris_1.IndexTable.Row, { id: order.number, key: `order:${order.number}:${index}`, position: index },
            react_1.default.createElement(styles_1.OrderNumberCell, { isProblemOrder: !!order.issues.edges.length },
                ordersHaveIssues && (react_1.default.createElement("div", { className: 'problem-order-icon', "data-testid": 'problem-order-icon' },
                    react_1.default.createElement(polaris_1.Icon, { accessibilityLabel: 'Problem Order', color: 'base', source: ProblemOrdersIcon_1.ProblemOrdersIcon }))),
                react_1.default.createElement(polaris_1.TextStyle, { variation: 'strong' }, order.number)),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, customerFullName),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, ((_a = order.customer) === null || _a === void 0 ? void 0 : _a.email) || 'N/A'),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, DateFormat_1.shortDateFormat)(order.insertedAt)),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null,
                react_1.default.createElement(styles_1.StyledRightAlignedTableCell, null,
                    react_1.default.createElement(polaris_1.Button, { onClick: () => {
                            setDetailedOrder(order);
                            setShowModal(true);
                        } }, "Details")))));
    });
    return (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'orders' },
        react_1.default.createElement(styles_1.HackTableFiltersStyling, null),
        ordersHaveIssues && react_1.default.createElement(styles_1.HackTableHeaderStyling, null),
        react_1.default.createElement(ProblemOrdersRules_1.ProblemOrdersRules, { onHide: () => setShowProblemOrderRules(false), show: showProblemOrderRules }),
        detailedOrder && (react_1.default.createElement(OrderModal_1.default, { display: showModal, handleToggleModal: handleToggleModal, order: detailedOrder })),
        react_1.default.createElement(styles_1.StyledHeaderContainer, null,
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, ordersCopy_1.ordersCopy.mainHeader),
            react_1.default.createElement(polaris_1.Button, { "aria-label": 'Problem Order Rules', icon: ProblemOrdersIcon_1.ProblemOrdersIcon, onClick: () => setShowProblemOrderRules(true) }, "Problem orders")),
        react_1.default.createElement(polaris_1.Card, null,
            react_1.default.createElement(styles_1.TableFiltersContainer, null,
                react_1.default.createElement(polaris_1.Filters, { appliedFilters: appliedFilters, filters: filters, focused: searched, key: 'filters', onClearAll: handleClearAll, onQueryChange: onQueryChange, onQueryClear: () => onQueryChange(''), queryPlaceholder: 'Filter orders', queryValue: searchQuery })),
            react_1.default.createElement(polaris_1.IndexTable, { emptyState: error ? (react_1.default.createElement(ErrorMessage_1.ErrorMessage, null)) : (react_1.default.createElement(EmptyState_1.EmptyState, { hasFilters: hasFilters, loading: loading })), headings: [
                    { title: 'Order' },
                    { title: 'Name' },
                    { title: 'Email' },
                    { title: 'Placed' },
                    { title: '' }
                ], itemCount: orders.length, lastColumnSticky: true, loading: loading, resourceName: resourceName, selectable: false }, rowMarkup)),
        ((_f = (_e = data === null || data === void 0 ? void 0 : data.orders) === null || _e === void 0 ? void 0 : _e.pageInfo) === null || _f === void 0 ? void 0 : _f.hasNextPage) && (react_1.default.createElement(styles_1.LoadMoreButtonContainer, null,
            react_1.default.createElement(polaris_1.Button, { id: 'load-more', onClick: handleLoadNext }, "Load More")))));
};
exports.default = Orders;
